export enum AlertSize {
  SMALL,
  MEDIUM,
  LARGE,
}
